<template>
    <PopupRouterView :showLeftIcon="true" label="Maintenance History Input"
        okTitle="Save"
        cancelTitle="Cancel"
        entityName="maintenancehistory"
        :documentId="mainRecordId"
        @saveMethod="saveAction"
        @hideMethod="onHidden"
        ref="maintenanceHistoryInput">


        <b-card header="Maintenance History" class="mb-3 card-max-width">
            <b-row>
				<b-col cols="12" lg="6">
						<!-- <app-input-combobox-autocomplete :options="workOrderExecutions" optionsLabel="shift" optionsKey="id" label-cols-lg="12" label="Work Order Execution" id="fieldset-work-order-executionn" size="sm" :model.sync="model.workOrderExecutionnId"   :selected="model.workOrderExecutionn != null ? model.workOrderExecutionn.shift : ''" @input="getWorkOrderExecutions"  :isUpdatable ="null" :isSelectMethodExists="true" @onSelectMethod="setSelectedWorkOrderExecutionn" /> -->
						<app-input-textarea id="fieldset-trouble-report" label-cols-lg="12"  label="Trouble Report" label-for="input-trouble-report" size="sm" :model.sync="model.troubleReport"   :isUpdatable ="null"/>
						<app-input-textarea id="fieldset-analisa-dan-penyebab" label-cols-lg="12"  label="Analisa dan Penyebab" label-for="input-analisa-dan-penyebab" size="sm" :model.sync="model.analisaDanPenyebab"   :isUpdatable ="null"/>
						<app-input-textarea id="fieldset-tindakan" label-cols-lg="12"  label="Tindakan" label-for="input-tindakan" size="sm" :model.sync="model.tindakan"   :isUpdatable ="null"/>
						<app-input-combobox-autocomplete :options="picTypes" optionsLabel="name" optionsKey="id" label-cols-lg="12" label="PIC Type" id="fieldset-pic-type" size="sm" :model.sync="model.picTypeId"   :selected="model.picType != null ? model.picType.name : ''" @input="getPicTypes"  :isUpdatable ="null" :isSelectMethodExists="true" @onSelectMethod="setSelectedPicType" />
						<app-input-textbox id="fieldset-pic-name" label-cols-lg="12"  label="Pic Name" label-for="input-pic-name" size="sm" :model.sync="model.picName"   :isUpdatable ="null"/>
					</b-col>
					<b-col cols="12" lg="6">
				</b-col>

            </b-row>
        </b-card>



        <b-overlay :show="isBusy" no-wrap></b-overlay>
    </PopupRouterView>
</template><script>
import axios from 'axios';
import { validationMixin } from "vuelidate";
import { required, minLength } from "vuelidate/lib/validators";
import MaintenanceHistory from '@/models/MaintenanceHistory/MaintenanceHistory';
import MaintenanceHistoryList from '@/models/MaintenanceHistory/MaintenanceHistoryList';
import MaintenanceHistoryFilter from '@/filters/MaintenanceHistory/MaintenanceHistoryFilter';

import AppInputComboboxAutocomplete from '@/components/AppInputComboboxAutocomplete';
import WorkOrderExecution from '@/models/WorkOrderExecution/WorkOrderExecution';
import WorkOrderExecutionFilter from '@/filters/WorkOrderExecution/WorkOrderExecutionFilter';
import AppInputTextarea from '@/components/AppInputTextarea';
import PicType from '@/models/PicType/PicType';
import PicTypeFilter from '@/filters/PicType/PicTypeFilter';
import AppInputTextbox from '@/components/AppInputTextbox';
import PopupRouterView from '@/components/PopupRouterView';
export default {
	components : {
		AppInputComboboxAutocomplete,
		AppInputTextarea,
		AppInputTextbox,
		PopupRouterView,
	},
	mixins : [validationMixin],
	validations: {
		model: {
		},
	},
	data() {
		return {
			errorMessage : {
			},
			datas: Array(),
			selectAll:false,
			sortBy: '',
			sortDesc: '',
			pagingOptions:[
				{ value : '10', text : '10', selected:true },
				{ value : '25', text : '25' },
				{ value : '50', text : '50' },
				{ value : '100', text : '100' },
			],
			busy:false,
			isBusy: false,
			isDataLoading: false,
			selected:'',
			pageSizeOptions: 10,
			pageIndex:0,
			sortingBy: Array(),
			modelId: null,
			model: {},
			filterMaintenanceHistory : null,
			currentMaintenanceHistoryPage : 1,
			maintenanceHistoryPageSize: 10,
			sortByMaintenanceHistory: '',
			sortDescMaintenanceHistory: '',
			workOrderExecutions: [],
			workOrderExecutionns: [],
			isWorkOrderExecutionnComboLoading: false,
			picTypes: [],
			picTypes: [],
			isPicTypeComboLoading: false,
			isShowPopupConfirmation : false,
			isDataCommited : false,
			mainRecordId : '',
			isWorkOrderExecutionComboLoading: false,
			isPicTypeComboLoading: false,
			woeid: '',
			isFromreport: false,
		}
	},
	methods : {
		showPopupWithMessage : async function(message) {
			const msg = this.$createElement;
			let msgNode = '';
			let result = false;
			msgNode = msg('div', { domProps: { innerHTML: '<p>'+message+'</p>' } })
			await this.$bvModal.msgBoxConfirm([msgNode], {
				title: 'Alert',
				size: 'sm',
				buttonSize: 'sm',
				okVariant: 'success',
				cancelVariant: 'secondary',
				okTitle: 'Yes',
				cancelTitle: 'No',
				footerClass: 'p-2',
				hideHeaderClose: false,
				centered: true
			}).then(e=>{
				if(e){
					result = true;
				}
			});
			return result;
		},
		getMaintenanceHistory : async function(id) {
			this.isBusy = true;
			MaintenanceHistory.getData(this, id).then(result => {
				this.model = result;
				this.mainRecordId = String(result.mainRecordId);
				let promises = Array();


				Promise.all(promises).then((results) => {
					this.isBusy = false;
				});
			}).catch(error => { this.isBusy = false; });
		},
		downloadData() {
			this.isDownloadMaintenanceHistory = true;
			this.filterMaintenanceHistory.id = this.modelId;
			MaintenanceHistory.downloadDataDetail(this, this.filterMaintenanceHistory).then(result => {
				this.isDownloadMaintenanceHistory = false;
			}).catch(error => { this.isDownloadMaintenanceHistory = false; })
		},
		getMaintenanceHistorys : async function(input) {
			let filter = new MaintenanceHistoryFilter();
			if (input != undefined) {
				filter.TroubleReport = input;
			}
			this.isMaintenanceHistoryComboLoading = true;
			MaintenanceHistory.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.maintenanceHistorys = result.data
				}
				this.isMaintenanceHistoryComboLoading = false;
			})
			.catch(error => {});
		},
		getWorkOrderExecutions : async function(input) {
			let filter = new WorkOrderExecutionFilter();
			if (input != undefined) {
				filter.shift = input;
			}
			WorkOrderExecution.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.workOrderExecutions = result.data
				}
			})
			.catch(error => {});
		},
		setSelectedWorkOrderExecutionn(item) {
			if(item == undefined || item == null) {
				this.model.workOrderExecutionnId = null;
				this.model.workOrderExecutionn = null;
			} else {
				this.model.workOrderExecutionnId = item.id;
				this.model.workOrderExecutionn = item;
			}
			this.$forceUpdate();
			this.updateData();
		},
		getPicTypes : async function(input) {
			let filter = new PicTypeFilter();
			if (input != undefined) {
				filter.name = input;
			}
			PicType.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.picTypes = result.data
				}
			})
			.catch(error => {});
		},
		setSelectedPicType(item) {
			if(item == undefined || item == null) {
				this.model.picTypeId = null;
				this.model.picType = null;
			} else {
				this.model.picTypeId = item.id;
				this.model.picType = item;
			}
			this.$forceUpdate();
			this.updateData();
		},
		validateState(name) {
			if (!this.$v.model[name]) return null;
			const { $dirty, $error } = this.$v.model[name];
			return $dirty ? !$error : null;
		},
		getErrorMessage(message, name) {
			if (!this.$v.model[name]) return "";
			if (this.$v.model[name].required != undefined && !this.$v.model[name].required) {
				if (message.required) return message.required;
			}
		},
		handleScroll() {
			this.$refs.maintenanceHistoryInput.scrollTop = 0;
		},
		saveAction(modalEvent) {
			modalEvent.preventDefault();
			this.handleScroll();
			let id = this.$route.params.id;
			this.$v.model.$touch(); 
			if (this.$v.model.$anyError) {
				return;
			} else {
				this.isBusy = true;
				let id = this.modelId;
				let model = this.model;

				let promises = Array();

				Promise.all(promises).then((results) => {
					if (id != '' && id != null && id != undefined) {
						MaintenanceHistory.updateData(this, model, id).then(result => {
							this.isDataCommited = true;
							if (result) {
								if(this.isFromreport) {
									this.$router.push({ name: 'reportmttrindex' });
								} else {
									this.$router.push({ name: 'maintenancehistoryindex' });
								}
							}
							this.isBusy = false;
						}).catch(error => { this.isBusy = false; });
					} else {
						MaintenanceHistory.insertData(this, model).then(result => {
							this.isDataCommited = true;
							if (result) {
								if(this.isFromreport) {
									this.$router.push({ name: 'reportmttrindex' });
								} else {
									this.$router.push({ name: 'maintenancehistoryindex' });
								}
							}
							this.isBusy = false;
						}).catch(error => { this.isBusy = false; });
					}
				});
			}
		},
		updateData() {
			let id = this.modelId;
			let model = this.model;
			let promises = Array();

			Promise.all(promises).then((results) => {
				if (id != '' && id != null && id != undefined) {
					MaintenanceHistory.updateData(this, model, id)
					.catch((error) => {
						this.getMaintenanceHistory(id);
					});
				}
			});
		},
		onHidden() {
			this.getMaintenanceHistorys();
		},
		resetModal(modalType) {
			this.showPopupCopyData = false; 
			this.isShowPopupConfirmation = false;
		},
		displayFilter() {
			this.windowWidth = window.innerWidth;
			if (this.windowWidth <= 768 ) {
			}
		},
	},
	beforeMount() {
		this.filterMaintenanceHistory = new MaintenanceHistoryFilter();
		//this.getWorkOrderExecutions();
		//this.getPicTypes();
	},
	async mounted(){
		let id = this.$route.params.id;
		let copyData = this.$route.params.copydata;
		if (id != '' && id != null && id != undefined) {
			if (copyData != null && copyData != undefined) {
				this.getMaintenanceHistory(id);
			} else {
				this.modelId = id;
				this.getMaintenanceHistory(id);
			}
		}

		let woeid = this.$route.params.woeid;
		if (woeid != '' && woeid != null && woeid != undefined) {
			this.woeid = woeid;
			this.model.workOrderExecutionnId = this.woeid;
			this.isFromreport = true;
		}

		this.$nextTick(() => {
			window.addEventListener('resize', this.displayFilter);
			this.displayFilter();
		});
	},
	computed: {
		isAllowSaveDraft: {
			get: function() {
				return true;
			}
		}
	},
	watch : {
	},
}
</script>
